import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import * as eventsService from '../services/eventsService';
import RegistrationFlow from '../components/Registration/RegistrationFlow';
import { mapEventRecord, REGISTRATION_COPY } from '../components/Registration/registrationConstants';

const Registration = () => {
  const { eventId } = useParams();
  const [event, setEvent] = useState(null);
  const [eventLoading, setEventLoading] = useState(true);
  const [eventError, setEventError] = useState(null);

  const refCode = typeof window === 'undefined'
    ? null
    : new URLSearchParams(window.location.search).get('ref');
  const queryLeadId = typeof window === 'undefined' ? null : new URLSearchParams(window.location.search).get('leadId');
  const queryEmail = typeof window === 'undefined' ? null : new URLSearchParams(window.location.search).get('email');

  useEffect(() => {
    let isActive = true;

    const fetchEvent = async () => {
      if (!eventId) {
        if (isActive) {
          setEvent(null);
          setEventError({ message: 'Event ID is required.' });
          setEventLoading(false);
        }
        return;
      }

      setEventLoading(true);
      setEventError(null);
      const { data, error } = await eventsService.getPublicEventById(eventId);

      if (!isActive) return;

      if (error) {
        setEvent(null);
        setEventError(error);
      } else if (data) {
        setEvent(mapEventRecord(data));
      } else {
        setEvent(null);
        setEventError({ message: 'Event not found.' });
      }
      setEventLoading(false);
    };

    fetchEvent();
    return () => { isActive = false; };
  }, [eventId]);

  const errorCopy = REGISTRATION_COPY.en;
  const loadingCopy = queryLeadId && queryEmail
    ? REGISTRATION_COPY.en.loadingRegistration
    : REGISTRATION_COPY.en.loadingEvent;

  if (eventLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin mx-auto mb-4" />
          <p className="text-gray-600">{loadingCopy}</p>
        </div>
      </div>
    );
  }

  if (!event || eventError) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">{errorCopy.eventNotFoundTitle}</h1>
          <p className="text-gray-600">{errorCopy.eventNotFoundDescription}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl mx-auto">
        <RegistrationFlow
          variant="standalone"
          eventId={eventId}
          event={event}
          refCode={refCode}
          queryLeadId={queryLeadId}
          queryEmail={queryEmail}
        />
      </div>
    </div>
  );
};

export default Registration;
